import * as React from 'react';
import type { SVGProps } from 'react';
const IconPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconPlay"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 4v16l13-8z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconPlay;
